import { FormType } from '@chegg-wt/core/constants/form'
import sourceTypes from '@chegg-wt/core/constants/sourceTypes'
import { createSelector } from 'reselect'

import { SourceType } from '@chegg-wt/core/types/core'
import { AppState } from '../types'

export const createCitationQuerySelector = (state: AppState) => state.createCitation.query

export const createCitationSearchResultsSelector = (state: AppState) =>
  state.createCitation.sources
export const createCitationErrorSelector = (state: AppState) => state.createCitation.error
export const createCitationSearchLoadingSelector = (state: AppState) =>
  state.createCitation.loading
export const createCitationSourceTypeSelector = (state: AppState) =>
  state.createCitation.sourceType

export const createCitationJournalTypeSelector = (state: AppState) =>
  state.createCitation.journalType

export const autociteV0RioOptFlagSelector = (state: AppState) =>
  state.createCitation.autociteV0RioOptFlag

export const oneClickFlagSelector = (state: AppState) => state.createCitation.oneClickFlag

export const autociteApiVersionSelector = (state: AppState) =>
  state.createCitation.autociteApiVersion

export const authModalExpFlagSelector = (state: AppState) =>
  state.createCitation.authModalExpFlag

export const formTypeSelector = (_: AppState, ownProps: { formType: FormType }) =>
  ownProps.formType

export const createCitationEncodedQuerySelector = createSelector(
  [createCitationQuerySelector],
  (query: string) => {
    try {
      return encodeURIComponent(query)
    } catch (e) {
      return query
    }
  }
)

export const currentSourceSelector = createSelector(
  [createCitationSourceTypeSelector],
  (currentSourceType: string): SourceType =>
    sourceTypes.find((sourceType) => sourceType.value === currentSourceType)
)

export const sourceTypeManualSelector = createSelector(
  [currentSourceSelector],
  (typeMatch: SourceType): boolean => typeMatch && typeMatch.manual
)

export const sourceTypeTitleSelector = createSelector(
  [currentSourceSelector],
  (typeMatch: SourceType): string => (typeMatch ? typeMatch.title : '')
)

export const sourceTypeNameSelector = createSelector(
  [currentSourceSelector],
  (typeMatch: SourceType): string => (typeMatch ? typeMatch.name : '')
)
